export default class ContractData {
  constructor ({
    name, taxNbr, zip, city, street,
    representativeLastName, representativeFirstName, representativePhone,
    contactFirstName, contactLastName, contactPhone, contactEmail,
    invoiceEmail, invoiceMailSameAsContact } = {}) {
    this.name = name || ''
    this.taxNbr = taxNbr || ''
    this.zip = zip || ''
    this.city = city || ''
    this.street = street || ''
    this.representativeLastName = representativeLastName || ''
    this.representativeFirstName = representativeFirstName || ''
    this.representativePhone = representativePhone || ''
    this.contactFirstName = contactFirstName || ''
    this.contactLastName = contactLastName || ''
    this.contactPhone = contactPhone || ''
    this.contactEmail = contactEmail || ''
    this.invoiceEmail = invoiceEmail || ''
    this.invoiceMailSameAsContact = invoiceMailSameAsContact || false
  }

  isValid () {
    return isNotEmpty([this.name, this.taxNbr, this.zip, this.city, this.street, this.representativeFirstName, this.representativeLastName, this.contactFirstName, this.contactLastName, this.contactPhone, this.contactEmail]) && ((!this.invoiceMailSameAsContact && isNotEmpty(this.invoiceEmail)) || this.invoiceMailSameAsContact)
  }
}

function isNotEmpty (arr) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === undefined || arr[i] === null || arr[i] === '') return false
  }
  return true
}
